module.exports = __webpack_public_path__ + "static/img/ent-90.c9a5ee8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-90.jpg
// module id = r46+
// module chunks = 51